import React, { useContext } from 'react';
import { classNames } from '../../utils/class-names.js';
import { __ } from '../../utils/i18n.js';
import { FormContext } from '../Form/FormContext.js';
import { ProgressButton } from '../../components/ProgressButton/ProgressButton.js';

const FormSubmitButton = ({ className, size, disabled, type = "submit", ...props })=>{
    const context = useContext(FormContext);
    if (!context) {
        throw new Error("FormSubmitButton must be used inside a Form component");
    }
    const isValid = context.form?.getState()?.valid !== false;
    const isVirtualForm = context.__virtual === true;
    return /*#__PURE__*/ React.createElement(ProgressButton, {
        className: classNames(className, !isValid && "btn-invalid"),
        size: size || context.size,
        disabled: disabled || context.readOnly,
        title: isValid ? undefined : __("Validációs hiba!"),
        type: isVirtualForm ? "button" : type,
        onClick: isVirtualForm ? context.handleSubmit : undefined,
        ...props
    });
};

export { FormSubmitButton };
//# sourceMappingURL=FormSubmitButton.js.map
